import React from "react"
import BaseModal from "helper/component/basemodal"
import { toggleModal } from "signals/modal"
import { param } from "signals/base"
import { confirm_type, selected_form_id } from "signals/user"
import { remove_address } from "services/user"
import { localize } from "services/base"

const Confirm = () => {
	const t = (key) => localize(key)

	const handleClose = () => {
		toggleModal({ name: "confirm", state: false })
	}
	const handleConfirm = () => {
		if (confirm_type.value === "delete") {
			const payload = {
				id: selected_form_id.value,
				event: {
					eventUrl: param.value?.eventUrl,
					apiUrl: param.value?.apiUrl,
				},
			}
			remove_address(payload)
		}
	}
	const renderMsg = () => {
		if (confirm_type.value === "delete") return "Are you sure you want to delete?"
	}
	return (
		<BaseModal tag={"confirm"}>
			<p className="confirm-text text-center">{renderMsg()}</p>
			<div className="d-flex justify-content-evenly">
				<div className="btn btn-decline btn-outline-light mt-4 btn-dark" onClick={() => handleClose()}>
					{t(`txt_no`)}
				</div>
				<div className="btn btn-accept btn-outline-light mt-4 btn-danger" onClick={() => handleConfirm()}>
					{t(`txt_yes`)}
				</div>
			</div>
		</BaseModal>
	)
}

export default Confirm
